import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type ISummaryLabelClasses =
  | 'boldLabel'
  | 'listText'
  | 'label'
  | 'payableLabel'
  | 'lineContainer'
  | 'textContainer'
  | 'repaymentLabel'
  | 'indicativeText'
  | 'tooltipIconButton'
  | 'tooltipIcon'
  | 'container'
  | 'vehicleTotalPrice'
  | 'driveAwayPrice'
  | 'comparisonLabel'
  | 'replacementLabel';

const summaryLabelStyles = makeStyles<ISpcTheme, ISummaryLabelClasses>(
  theme => ({
    boldLabel: {
      fontWeight: 'bold',
      wordBreak: 'break-word',
    },
    label: {
      fontSize: theme.typography.fontMD,
      wordBreak: 'break-word',
    },
    payableLabel: {},
    listText: {
      fontSize: theme.typography.fontMD,
    },
    lineContainer: {
      marginTop: 0,
      marginBottom: 0,
    },
    textContainer: {
      textAlign: 'end',
    },
    repaymentLabel: {},
    indicativeText: {},
    tooltipIconButton: {
      marginLeft: '4px',
      padding: 0,
      verticalAlign: 'top',
    },
    tooltipIcon: {
      fontSize: theme.typography.fontLG,
    },
    container: {},
    vehicleTotalPrice: {},
    driveAwayPrice: {},
    comparisonLabel: {},
    replacementLabel: {},
  }),
  { name: 'Customise_PriceLabel' },
);

export default summaryLabelStyles;
